export class Task {
    name: string;
    description: string;
    isExecuting: boolean;
    successful: boolean;
    finishedAt: Date;
    read?: boolean;
    key?: string | number;

    // Successful
    messageSuccessful: string;

    // Error
    titleError: string;
    messageError: string;
    error: any;

    constructor(name: string, description?: string) {
        this.name = name;
        this.description = description;
    }
}
